




























































import { Component, Prop, Watch } from 'vue-property-decorator';
import { Communicate } from '../../../src_server/entity/generated/Communicate';
import YoutubeFrame from '../../components/inputs/YoutubeFrame.vue';
import { ActorType, CommunicationMethod, Deafness } from '../../../src_server/biz/ActorType';
import { InputPages } from '../../components/organisms/InputPages';
import { communicateOptions } from '../../../src_server/entity/master/communicateOptions';
import ErrorSummary from '../../components/inputs/ErrorSummary.vue';

@Component({
  components: { YoutubeFrame, ErrorSummary },
})
export default class StudentCommunicationPage extends InputPages {
  @Prop()
  value!: Communicate;

  get communicate() {
    return communicateOptions;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  @Watch('model.sign_language')
  @Watch('model.corresponding_sign_language')
  @Watch('model.pronunciation')
  detect() {
    console.log('detect');
    const actor = ActorType.getInstance(
      'Deaf', // this.model.hearing_type as Deafness,
      false,
      this.model.sign_language as CommunicationMethod,
      this.model.corresponding_sign_language as CommunicationMethod,
      this.model.pronunciation as CommunicationMethod
    );
    this.model.actor_type = actor.type;
  }
  get model(): Communicate {
    return this.value;
  }

  set model(value: Communicate) {
    this.value = value;
  }
}
